(function($) {
    
    // CF7 events
	const cf7 = document.querySelectorAll('.wpcf7 form')
	
	if(cf7) {
		cf7.forEach(form => {
			const button = form.querySelector('button[type=submit], input[type="submit"]')
			
			form.addEventListener('submit', function() {
				button.setAttribute('disabled', true)
				button.classList.add('loading')
			})
		
			form.addEventListener('wpcf7submit', function() {
				button.removeAttribute('disabled')
				button.classList.remove('loading')
			})
		})
	}
	
    // Mask phone input
    let phoneMaskFunction = function(val) {
    	return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
    }
    
    $('input[type="tel"]').mask(phoneMaskFunction, {
    	onKeyPress: function(val, e, field, options) {
    		field.mask(phoneMaskFunction.apply({}, arguments), options);
    	}
    });
    
})(jQuery);